import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { trackEstimate, trackWhatsApp } from "@/lib/track";

export default function FinalCTA() {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="py-20 lg:py-28 bg-neutral-950 text-white relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-[#C5A059]/8 blur-3xl rounded-full -translate-y-1/2 translate-x-1/4" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-4">
          Get Started
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight mb-5 leading-[1.05]">
          Ready to Renovate Your Property?
        </h2>
        <p className="text-base lg:text-lg text-neutral-300 leading-relaxed max-w-2xl mx-auto mb-3">
          Don&apos;t start by guessing your renovation budget. Start by showing us the property.
        </p>
        <p className="text-base lg:text-lg text-neutral-300 leading-relaxed max-w-2xl mx-auto mb-10">
          Send us photos or videos and we&apos;ll provide a rough renovation estimate — then arrange a <span className="text-[#E2C988] font-medium">free site inspection</span> for the actual price.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 mb-6">
          <a href="#lead-form" data-testid="final-cta-estimate" onClick={() => trackEstimate("final_cta")}>
            <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-7 py-7 text-base font-semibold w-full sm:w-auto tracking-wide">
              GET MY ROUGH RENOVATION ESTIMATE
            </Button>
          </a>
          <a
            href={COMPANY.estimateLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            onClick={() => trackWhatsApp("final_cta")}
          >
            <Button className="bg-[#25D366] hover:bg-[#1ebd5a] text-white rounded-none px-7 py-7 text-base font-semibold w-full sm:w-auto tracking-wide">
              <MessageCircle className="w-5 h-5 mr-2" /> WHATSAPP US
            </Button>
          </a>
        </div>

        <p className="text-xs text-neutral-500 tracking-wide">
          Photos/Videos → Rough Estimate → Free Site Inspection → Detailed Quotation
        </p>
      </div>
    </section>
  );
}
